export default function Teammates() {
  const teammates = [
    {
      name: 'CoolGamer2025',
      avatar: 'https://public.readdy.ai/ai/img_res/1983ffbabc503a36a9568e4dd943cbd7.jpg',
      gamesPlayed: 234,
    },
    {
      name: 'ProBuilder99',
      avatar: 'https://readdy.ai/api/search-image?query=Roblox%20builder%20character%20construction%20themed%20outfit%20creative%20player%20professional%20gaming%20unique%20style&width=200&height=200&seq=teammate-avatar-2-v3&orientation=squarish',
      gamesPlayed: 189,
    },
    {
      name: 'SpeedRunner_X',
      avatar: 'https://readdy.ai/api/search-image?query=Roblox%20speedrunner%20avatar%20athletic%20gaming%20character%20sporty%20outfit%20energetic%20player%20competitive%20style&width=200&height=200&seq=teammate-avatar-3-v3&orientation=squarish',
      gamesPlayed: 156,
    },
    {
      name: 'MegaStar777',
      avatar: 'https://readdy.ai/api/search-image?query=Roblox%20VIP%20character%20premium%20luxury%20outfit%20exclusive%20accessories%20celebrity%20gaming%20glamorous%20design&width=200&height=200&seq=teammate-avatar-4-v3&orientation=squarish',
      gamesPlayed: 142,
    },
  ];

  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32">
      {/* Section Header */}
      <div className="text-center mb-12 sm:mb-16">
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 px-2 leading-tight">
          С кем вы были в одной команде
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-white/60 max-w-2xl mx-auto px-4">
          Ваши самые частые тиммейты 2025 года.
        </p>
      </div>

      {/* Teammates Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {teammates.map((teammate, index) => (
          <div
            key={index}
            className="bg-white/5 rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-8 text-center hover:bg-white/10 hover:-translate-y-2 hover:shadow-[0_0_40px_rgba(0,212,255,0.2)] transition-all duration-300 cursor-pointer"
          >
            {/* Avatar */}
            <div className="relative w-20 h-20 sm:w-24 sm:h-24 lg:w-32 lg:h-32 mx-auto mb-3 sm:mb-5">
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#00d4ff]/30 to-[#a855f7]/30 blur-xl" />
              <img
                src={teammate.avatar}
                alt={teammate.name}
                className="relative w-full h-full object-cover object-top rounded-full border-2 sm:border-4 border-[#00d4ff]/30"
              />
            </div>

            {/* Name */}
            <h3 className="text-sm sm:text-base lg:text-xl font-bold text-white mb-2 break-words">
              {teammate.name}
            </h3>

            {/* Stats */}
            <div className="flex items-center justify-center gap-1 sm:gap-2 text-white/60">
              <i className="ri-gamepad-line text-[#00d4ff] text-sm sm:text-base w-4 h-4 flex items-center justify-center"></i>
              <span className="text-xs sm:text-sm">
                {teammate.gamesPlayed} игр
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
